import { render, staticRenderFns } from "./AddEditSpu.vue?vue&type=template&id=5d0991f6&scoped=true"
import script from "./AddEditSpu.vue?vue&type=script&lang=js"
export * from "./AddEditSpu.vue?vue&type=script&lang=js"
import style0 from "./AddEditSpu.vue?vue&type=style&index=0&id=5d0991f6&prod&scoped=true&lang=css"
import style1 from "./AddEditSpu.vue?vue&type=style&index=1&id=5d0991f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0991f6",
  null
  
)

export default component.exports